export {
  defineConstProperty,
  defineProducedProperty,
  defineProducedPropertyOnClass,
  defineComputedProperty,
  hasOwnProperty
} from './src/properties';

